import { createActionGroup, emptyProps, props } from '@ngrx/store';

import { FilterObjectType, FilterSavedState } from './inline-filter.models';

export const InlineFilterActions = createActionGroup({
    source: 'InlineFilter',
    events: {
        'Set enriched configs': props<{ enriched: Record<string, StorytellingFilterDefinition[]> }>(),

        'Set all filter states': props<{ states: Record<string, Record<string, FilterSavedState>> }>(),

        'Update filter state': props<{ objectType: FilterObjectType; section: string; state: FilterSavedState }>(),

        'Save filter state': props<{ objectType: FilterObjectType; section: string }>(),
        'Save filter state success': props<{ objectType: FilterObjectType; section: string; state: FilterSavedState }>(),

        'Revert filter state': props<{ objectType: FilterObjectType; section: string }>(),

        'Clear filter state': props<{ objectType: FilterObjectType; section: string }>(),

        Reset: emptyProps(),
    },
});
